import { CaseMetadata } from './CaseMetadata';
import type { ScanGeometries, RestorativeModel } from './FinishingApp.types';
import React from 'react';

export function useCaseMetadata(restorativeModels: RestorativeModel[], scans: ScanGeometries): CaseMetadata {
    return React.useMemo(() => new CaseMetadata(restorativeModels, scans), [restorativeModels, scans]);
}
